import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import ProtectedRouteV2 from "./ProtectedRouteV2";
import CalendarEvents from "../pages/Calendar/CalendarEvents";
import CalendarAgenda from "../pages/Calendar/CalendarAgenda";

/**
 * 🗓️ calendarRoutes
 *
 * Rutas protegidas del módulo "Calendario".
 * - Totalmente alineadas con las rutas del backend (CalendarMenuBuilder).
 * - Incluye vistas para "Eventos" y "Agenda".
 */
const calendarRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    {/* 🔹 Eventos */}
    <Route
      path="/calendar/events"
      element={
        <>
          <PageTitle title="Eventos | Codenova POS" />
          <CalendarEvents />
        </>
      }
    />

    {/* 🔹 Agenda */}
    <Route
      path="/calendar/agenda"
      element={
        <>
          <PageTitle title="Agenda | Codenova POS" />
          <CalendarAgenda />
        </>
      }
    />
  </Route>
);

export default calendarRoutes;
